// extracted by mini-css-extract-plugin
module.exports = {"Movie":"Movie_Movie__32w0m","Movie_Info":"Movie_Movie_Info__2L4I-","Img":"Movie_Img__1KMbW","Info":"Movie_Info__2jdUk"};